import React from 'react'
import AboutNav from '../Components/Navigation/AboutNav'
import Footer from '../Components/Home/Footer'
import SEBISlider from '../Components/Common/SEBISlider'
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import { FaCertificate, FaExchangeAlt, FaShieldAlt, FaFileContract } from 'react-icons/fa';
import "../Assets/Styles/Pages/about_page.css"
import "../Assets/Styles/particles.css"
import { Helmet } from 'react-helmet';

const AboutUs_page = () => {
  return (
    <>
      <Helmet>
        <title>About Us | Trillion Stock Research</title>
        <meta name="description" content="Learn about Trillion Stock Research, our mission, vision, and commitment to providing the best investment advisory and stock market research services." />
        <meta name="keywords" content="about Trillion Stock Research, investment advisory, stock research, financial growth, company values" />
        <link rel="canonical" href="https://www.trillionstockresearch.com/about" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Trillion Stock Research",
            "url": "https://www.trillionstockresearch.com/",
            "logo": "https://www.trillionstockresearch.com/logo.png",
            "contactPoint": [{
              "@type": "ContactPoint",
              "telephone": "+91 9977555378",
              "contactType": "customer service",
              "areaServed": "IN"
            }],
            "sameAs": [
              "https://www.facebook.com/trillionstockresearch",
              "https://twitter.com/trillionstock"
            ]
          }
        `}</script>
      </Helmet>
      <div className="about-page">
        <AboutNav />
        <SEBISlider />
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-content">
            <h1>About Trillion Stock Research</h1>
            <p>SEBI Registered Investment Advisory Firm</p>
          </div>
        </section>

        {/* Main Content */}
        <section className="about-main">
          <div className="about-container">
            <div className="about-content">
              <h2>Company Background</h2>
              <p>Trillion Stock Research is a SEBI-registered investment advisory firm based in Indore, Madhya Pradesh. We provide stock market research and investment advisory services to retail investors and traders.</p>
              
              <div className="about-stats">
                <div className="stat-item">
                  <h3>2025</h3>
                  <p>SEBI Registration</p>
                </div>
                <div className="stat-item">
                  <h3>Indore</h3>
                  <p>Head Office</p>
                </div>
                <div className="stat-item">
                  <h3>INH000020129</h3>
                  <p>SEBI Number</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about-mission">
          <div className="about-container">
            <div className="mission-content">
              <div className="mission-box">
                <h2>Services</h2>
                <p>We offer stock market research reports, trading recommendations, and investment advisory services as per SEBI regulations.</p>
              </div>
              <div className="vision-box">
                <h2>Regulatory Status</h2>
                <p>Registered with SEBI as Research Analyst under Registration No. INH000020129, effective from March 24, 2025.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="about-values">
          <div className="about-container">
            <h2>Compliance & Standards</h2>
            <div className="values-grid">
              <div className="value-item">
                <FaCertificate />
                <h3>SEBI Registered</h3>
                <p>Authorized to provide investment advisory services</p>
              </div>
              <div className="value-item">
                <FaExchangeAlt />
                <h3>BSE Listed</h3>
                <p>BSE Enlistment No.: 6528</p>
              </div>
              <div className="value-item">
                <FaShieldAlt />
                <h3>Regulatory Compliance</h3>
                <p>Following SEBI guidelines and regulations</p>
              </div>
              <div className="value-item">
                <FaFileContract />
                <h3>Transparency</h3>
                <p>Clear disclosure of services and terms</p>
              </div>
            </div>
          </div>
        </section>



        <section className="about-grievance">
          <div className="about-container">
            <div className="grievance-content">
              <h2>Grievance Redressal / Escalation Matrix</h2>
              <p className="grievance-intro">If you have a grievance, you can reach out to our Support Team for assistance.</p>
              
              <div className="grievance-table">
                <div className="grievance-row header">
                  <div className="grievance-cell">Designation</div>
                  <div className="grievance-cell">Contact Person</div>
                  <div className="grievance-cell">Address</div>
                  <div className="grievance-cell">Contact No.</div>
                  <div className="grievance-cell">Email-ID</div>
                  <div className="grievance-cell">Working Hours</div>
                </div>
                
                <div className="grievance-row">
                  <div className="grievance-cell" data-label="Designation">Customer Care</div>
                  <div className="grievance-cell" data-label="Contact Person">Prachi Sharma</div>
                  <div className="grievance-cell" data-label="Address">200 Sector A, Suryadev Nagar, Indore, Madhya Pradesh, 452012</div>
                  <div className="grievance-cell" data-label="Contact No.">+91 9977555378</div>
                  <div className="grievance-cell" data-label="Email-ID">prachisharma33777@gmail.com</div>
                  <div className="grievance-cell" data-label="Working Hours">Mon-Sat<br/>09AM – 05 PM</div>
                </div>
                
                <div className="grievance-row">
                  <div className="grievance-cell" data-label="Designation">Head of Customer Care</div>
                  <div className="grievance-cell" data-label="Contact Person">Prachi Sharma</div>
                  <div className="grievance-cell" data-label="Address">200 Sector A, Suryadev Nagar, Indore, Madhya Pradesh, 452012</div>
                  <div className="grievance-cell" data-label="Contact No.">+91 9977555378</div>
                  <div className="grievance-cell" data-label="Email-ID">prachisharma33777@gmail.com</div>
                  <div className="grievance-cell" data-label="Working Hours">Mon-Sat<br/>09AM – 05 PM</div>
                </div>
                
                <div className="grievance-row">
                  <div className="grievance-cell" data-label="Designation">Compliance Officer</div>
                  <div className="grievance-cell" data-label="Contact Person">Prachi Sharma</div>
                  <div className="grievance-cell" data-label="Address">200 Sector A, Suryadev Nagar, Indore, Madhya Pradesh, 452012</div>
                  <div className="grievance-cell" data-label="Contact No.">+91 9977555378</div>
                  <div className="grievance-cell" data-label="Email-ID">prachisharma33777@gmail.com</div>
                  <div className="grievance-cell" data-label="Working Hours">Mon-Sat<br/>09AM – 05 PM</div>
                </div>
                
                <div className="grievance-row">
                  <div className="grievance-cell" data-label="Designation">CEO</div>
                  <div className="grievance-cell" data-label="Contact Person">–</div>
                  <div className="grievance-cell" data-label="Address">–</div>
                  <div className="grievance-cell" data-label="Contact No.">–</div>
                  <div className="grievance-cell" data-label="Email-ID">–</div>
                  <div className="grievance-cell" data-label="Working Hours">–</div>
                </div>
                
                <div className="grievance-row">
                  <div className="grievance-cell" data-label="Designation">Principal Officer</div>
                  <div className="grievance-cell" data-label="Contact Person">Prachi Sharma</div>
                  <div className="grievance-cell" data-label="Address">200 Sector A, Suryadev Nagar, Indore, Madhya Pradesh, 452012</div>
                  <div className="grievance-cell" data-label="Contact No.">+91 9977555378</div>
                  <div className="grievance-cell" data-label="Email-ID">prachisharma33777@gmail.com</div>
                  <div className="grievance-cell" data-label="Working Hours">Mon-Sat<br/>09AM – 05 PM</div>
                </div>
              </div>

              <div className="grievance-info">
                <p>The abovementioned details would facilitate the complainants to approach the concerned RA before filing complaint to SEBI. For more details go to: <a href="https://www.bseindia.com/markets/MarketInfo/DispNewNoticesCirculars.aspx?page=20241209-41" target="_blank" rel="noopener noreferrer">BSE Circular</a></p>
                
                <div className="grievance-timeline">
                  <h4>Resolution Timeline</h4>
                  <p>We aim to resolve all grievances within <strong>21 working days</strong> from the date of receipt.</p>
                </div>

                <div className="grievance-escalation">
                  <h4>Escalation Process</h4>
                  <div className="escalation-steps">
                    <div className="escalation-step">
                      <span className="step-number">1</span>
                      <div className="step-content">
                        <h5>Internal Resolution</h5>
                        <p>Contact our support team first for resolution</p>
                      </div>
                    </div>
                    <div className="escalation-step">
                      <span className="step-number">2</span>
                      <div className="step-content">
                        <h5>SEBI SCORES Platform</h5>
                        <p>If unresolved within 21 days, escalate to <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer">scores.sebi.gov.in</a></p>
                      </div>
                    </div>
                    <div className="escalation-step">
                      <span className="step-number">3</span>
                      <div className="step-content">
                        <h5>ODR Portal</h5>
                        <p>For further escalation, use <a href="https://smartodr.in" target="_blank" rel="noopener noreferrer">smartodr.in</a></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <ISOCertificateButton />
      </div>
    </>
  )
}

export default AboutUs_page